import TranslatableTextField from './TranslatableTextField';

export default TranslatableTextField;
